'use client'

import type { FC } from 'react'
import { Label } from 'ui/label'
import { Textarea } from 'components/ui/textarea'
import FieldWrapper from './FieldWrapper'
import type { FieldRendererProps } from './types'

const TextareaField: FC<FieldRendererProps> = ({ field, value, error, onChange }) => {
    return (
        <FieldWrapper fieldName={field.name} error={error}>
            <Label htmlFor={field.name}>{field.label}</Label>
            <Textarea
                name={field.name}
                value={String(value ?? '')}
                disabled={!!field?.disabled}
                onChange={e => onChange(field.name, e.target.value, field)}
                required={field.required}
            />
        </FieldWrapper>
    )
}

export default TextareaField
